__turbopack_context__.v({
  "brand-image": "layout-module-scss-module__uQLIpG__brand-image",
  "container": "layout-module-scss-module__uQLIpG__container",
  "header-container": "layout-module-scss-module__uQLIpG__header-container",
  "header-title": "layout-module-scss-module__uQLIpG__header-title",
  "image-wrapper": "layout-module-scss-module__uQLIpG__image-wrapper",
  "main": "layout-module-scss-module__uQLIpG__main",
  "overview": "layout-module-scss-module__uQLIpG__overview",
  "overview-description": "layout-module-scss-module__uQLIpG__overview-description",
  "visitation": "layout-module-scss-module__uQLIpG__visitation",
});
